import React, { useRef } from "react";
import { motion } from "framer-motion";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import RowContainer from "./RowContainer";

const FoodItemsContainer = ({ foodItems, title, dataKey, flag }) => {
  const rowContainerRef = useRef();

  const scroll = (scrollOffset) => {
    rowContainerRef.current.scrollLeft += scrollOffset;
  };

  return (
    <>
      <section className="w-full my-6">
        <div className="w-full flex items-center justify-between">
          <p className="text-2xl font-semibold relative uppercase text-headingColor before:absolute before:rounded-lg before:content before:w-32  before:h-1 before:-bottom-2 before:left-0 before:bg-gradient-to-tr from-orange-400 to-orange-600 duration-100 transition-all ease-in-out">
            {title}
          </p>
          <div className="hidden md:flex gap-3 items-center">
            <motion.div
              whileTap={{ scale: 0.75 }}
              onClick={() => {
                scroll(-200);
              }}
              className="w-8 h-8 rounded-lg bg-orange-300 hover:bg-orange-500 cursor-pointer flex items-center justify-center transition-all duration-100 ease-in-out hover:shadow-lg"
            >
              <MdChevronLeft className="text-lg text-white" />
            </motion.div>
            <motion.div
              whileTap={{ scale: 0.75 }}
              onClick={() => {
                scroll(200);
              }}
              className="w-8 h-8 rounded-lg bg-orange-300 hover:bg-orange-500 cursor-pointer flex items-center justify-center transition-all duration-100 ease-in-out hover:shadow-lg"
            >
              <MdChevronRight className="text-lg text-white" />
            </motion.div>
          </div>
        </div>
        <RowContainer
          rowContainerRef={rowContainerRef}
          flag={flag}
          data={foodItems?.filter((item) => item.title.includes(dataKey))}
        />
      </section>
    </>
  );
};

export default FoodItemsContainer;
